module.exports = __webpack_public_path__ + "img/step4-4.fda01c93.png";